module.exports = __webpack_public_path__ + "static/img/0.6574965.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/views/docs/image/0.jpeg
// module id = 176
// module chunks = 1